import { LiveAnnouncer } from '@angular/cdk/a11y';
import * as i0 from '@angular/core';
import { inject, Component, Input, NgModule } from '@angular/core';
import { timer } from 'rxjs';
import { LOADING_INDICATOR_PRIMARY, LOADING_INDICATOR_SECONDARY } from '@virginmediao2/momentum-angular/tokens';

class LoadingLogoComponent {
    constructor() {
        this.#liveAnnouncer = inject(LiveAnnouncer);
        this.primaryPath = inject(LOADING_INDICATOR_PRIMARY);
        this.secondaryPath = inject(LOADING_INDICATOR_SECONDARY);
        this.announceRepeat = 10000;
        this.message = 'loading';
        /** Sets the variant for loading animation */
        this.variant = 'primary';
        this.path = '';
    }
    #liveAnnouncer;
    ngOnInit() {
        this.path = this.variant === 'primary' ? this.primaryPath : this.secondaryPath;
        this.counter$ = timer(this.announceRepeat, this.announceRepeat).subscribe(() => this.#liveAnnouncer.announce(this.message));
    }
    ngOnDestroy() {
        this.counter$?.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: LoadingLogoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: LoadingLogoComponent, isStandalone: true, selector: "vo-loading-logo", inputs: { announceRepeat: "announceRepeat", message: "message", dataTestId: ["data-testid", "dataTestId"], width: "width", height: "height", variant: "variant" }, host: { properties: { "attr.aria-label": "null" } }, ngImport: i0, template: "<img [attr.aria-label]=\"message\"\n     [src]=\"path\"\n     [style.height]=\"height\"\n     [style.width]=\"width\"\n     alt=\"Loading animation\"\n     data-testid=\"loading-animation\" id=\"loading-animation\"/>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: LoadingLogoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vo-loading-logo', standalone: true, host: {
                        '[attr.aria-label]': 'null',
                    }, template: "<img [attr.aria-label]=\"message\"\n     [src]=\"path\"\n     [style.height]=\"height\"\n     [style.width]=\"width\"\n     alt=\"Loading animation\"\n     data-testid=\"loading-animation\" id=\"loading-animation\"/>\n" }]
        }], propDecorators: { announceRepeat: [{
                type: Input
            }], message: [{
                type: Input
            }], dataTestId: [{
                type: Input,
                args: ['data-testid']
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], variant: [{
                type: Input
            }] } });

class LoadingLogoModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: LoadingLogoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: LoadingLogoModule, imports: [LoadingLogoComponent], exports: [LoadingLogoComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: LoadingLogoModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: LoadingLogoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [LoadingLogoComponent],
                    exports: [LoadingLogoComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LoadingLogoComponent, LoadingLogoModule };
